import React from "react";
import {t} from "i18next";

const SendingNotAllowedWarning = () => {
    return (
        <div className="error global">{t('feedback.tooManyMessages')}</div>
    )
}

export default SendingNotAllowedWarning